module.exports = __webpack_public_path__ + "img/btn_menu_all_c.958d916a.png";